/**
 * Frontend runtime configuration. All values come from Vite env vars
 * (prefixed VITE_) so they can be set per-environment at build time.
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

export const TOKEN_STORAGE_KEY = 'token';
export const USER_STORAGE_KEY = 'user';

/**
 * Concern 9db69fc5 — gates the login page's one-click QA-demo sign-in buttons. A DEDICATED,
 * explicit flag (NOT `import.meta.env.DEV`, which is on for every local dev boot) — this only
 * controls whether the buttons RENDER; the backend's own `DEMO_MODE` (backend/src/config/env.js)
 * is what actually enforces the gate, so leaving this true while the backend flag is off just
 * means the buttons show and then fail with the normal invalid-credentials error, never a bypass.
 * Vite inlines `VITE_`-prefixed vars as string literals at build time, so a production build with
 * this unset/false tree-shakes the demo UI out entirely.
 */
export const DEMO_MODE_ENABLED = import.meta.env.VITE_DEMO_MODE === 'true';
